import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

type Props = {
    title: string;
    description?: string;
    children: ReactNode;
};

export function SlaFormSection({ title, description, children }: Props) {
    return (
        <Box
            sx={{
                border: 1,
                borderColor: 'divider',
                borderRadius: 2,
                bgcolor: 'action.hover',
                p: { xs: 2, sm: 2.5 }
            }}
        >
            <Stack spacing={0.5} sx={{ mb: 2 }}>
                <Typography variant="subtitle2" fontWeight={600} color="text.primary">
                    {title}
                </Typography>
                {description && (
                    <Typography variant="caption" color="text.secondary" display="block">
                        {description}
                    </Typography>
                )}
            </Stack>
            {children}
        </Box>
    );
}
